import { useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValueLoadable, useResetRecoilState } from 'recoil';
import { isObeBeingMoved as isObeBeingMovedSelector } from 'api/obes/getIsObeBeingMoved';
import { UNREGISTER } from 'routes/overview/UnregisterTag/paths';
import { unregisterVehicle, unregisterVehicles as vehicles, currentTagOption as tagOption, confirmInfo as confirmed } from 'state/unregisterVehicle';
import objectHasValues from 'utils/general/objectHasValues';
import checkLoadable from 'utils/recoil/checkLoadable';
export default function useUnregisterVehicle() {
  const {
    push
  } = useHistory();
  const [currentVehicle, setCurrentVehicle] = useRecoilState(unregisterVehicle);
  const [unregisterVehicles, setUnregisterVehicles] = useRecoilState(vehicles);
  const [currentTagOption, setCurrentTagOption] = useRecoilState(tagOption);
  const [confirmInfo, setConfirmInfo] = useRecoilState(confirmed);
  const isObeBeingMovedLoadable = useRecoilValueLoadable(isObeBeingMovedSelector(currentVehicle?.obeId));
  const {
    contents: isObeBeingMoved
  } = checkLoadable(isObeBeingMovedLoadable);
  const validVehicle = currentVehicle && objectHasValues(currentVehicle) && !isObeBeingMoved;

  // Reset functions
  const resetCurrentVehicle = useResetRecoilState(unregisterVehicle);
  const resetCurrentVehicles = useResetRecoilState(vehicles);
  const resetTagOption = useResetRecoilState(tagOption);
  const resetConfirmInfo = useResetRecoilState(confirmed);
  const reset = () => {
    resetCurrentVehicle();
    resetCurrentVehicles();
    resetTagOption();
    resetConfirmInfo();
  };
  const resetCurrentProcess = () => {
    resetCurrentVehicle();
    resetTagOption();
    resetConfirmInfo();
  };
  const returnToFirstPage = () => {
    reset();
    push(UNREGISTER);
  };
  const removeVehicle = chosenVehicle => {
    const updatedVehicles = unregisterVehicles.filter(vehicle => vehicle.obeId !== chosenVehicle.obeId);
    setUnregisterVehicles(updatedVehicles);
  };
  return {
    confirmInfo,
    validVehicle,
    currentVehicle,
    currentTagOption,
    unregisterVehicles,
    isObeBeingMoved,
    reset,
    setConfirmInfo,
    returnToFirstPage,
    setCurrentVehicle,
    setCurrentTagOption,
    setUnregisterVehicles,
    resetCurrentProcess,
    removeVehicle,
    resetCurrentVehicle
  };
}